import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import {
  activeStepVar,
  currentUserVar
} from 'modulesCommon/store'
import { useReactiveVar } from '@apollo/client'
import { useZonesList } from 'modulesCommon/serviceHooks'

const LAST_STEP = 4

const usePreviewStepProject = () => {
  const { pathname, state } = useLocation()
  const currentUser = useReactiveVar(currentUserVar)
  const { zoneList } = useZonesList()

  const navigate = useNavigate()

  const userLocalizeZone = zoneList.find((zone) => zone.id === currentUser.label_id)

  const onPreviewProject = () => navigate(`${pathname}/preview`)

  const onExit = () => {
    navigate(pathname.replace('/preview', ''), { state: { step: LAST_STEP }})
  }

  useEffect(() => {
    if (state?.step) {
      activeStepVar(state.step)
    }
  }, [state?.step])

  return {
    onPreviewProject,
    sourceZoneTitle: userLocalizeZone?.name ?? '',
    sourceZoneCode: userLocalizeZone?.alias ?? '',
    onExit
  }
}

export default usePreviewStepProject
